export const ERROR_CODES = {
  ERROR: "ERROR",
  UNDEFINED: "undefined",
  CONNECTION_TIMEOUT: "connection_timeout",
  ECONNABORTED: "ECONNABORTED",

  WS_CONNECT_FAILED: "ws_connect_failed",
  REGULATION_INIT_TIMEOUT: "regulation_limit_timeout",

  INTERNAL_SERVER_ERROR: "internal_server_error",
  REG_TIME_LIMIT: "reg_time_limit",

  BAD_RESPONSE: "bad_response",
  BAD_REQUEST: "bad_request",

  GAME_NOT_ENOUGH_CREDIT: "game_not_enough_credit",
  GAME_RUNNING: "game_running",
  GAME_NOT_ENABLED: "game_not_enabled",

  ERROR_BUTTONS: 6002,
  SETTINGS_ERROR: 6003,

  GAME_NOT_FOUND: 1003,
  SESSION_NOT_FOUND: 1004,
  ROUND_NOT_FOUND: 1005,

  SESSION_CLOSED: 2001,
  ROUND_ENDED: 2003,

  ANOTHER_GAME_OPEN: 2012,

  REDIRECT: 3002,
  INSUFFICIENT_CREDIT: 3003,
  FREESPINS_EXPIRED: 3004,
  FREESPINS_ALREADY_REDEEMED: 3005,

  SERVICE_UNAVAILABLE: 4001,

  WALLET_AUTH_FAILED: 5001,
  WALLET_SERVER_EXC: 5002,
  WALLET_BLOCKS_BET: 5003,
  WALLET_BLOCKS_WIN: 5004,
  PLAYER_LIMIT_EXCEEDED: 5005,
  WALLET_BLOCKS_PLAYER: 5006,
  WALLET_CLOSED_GAME: 5008,
  WALLET_CANCEL_DUPLICATE: 5492,

  COOLDOWN: 5015,

  CZECH_REGULATION: 50100,
  DAILY_LOSS_LIMIT: 5010,
  WEEK_LOSS_LIMIT: 50110,
  MONTH_LOSS_LIMIT: 5011,
  DAILY_BET_LIMIT: 5012,
  WEEKLY_BET_LIMIT: 50120,
  MONTHLY_BET_LIMIT: 5013,
  MORE_WINDOWS_OPENED: 5014,
  LIMIT_IS_MISSING: 5016,
  WITHDRAW_LIMIT: 5017,
  LEGISLATION_NOT_SUPPORTED: 5018,
  PLAYTIME_LIMIT: 5019,
  HOUR_LOSS_LIMIT: 5020,
  WALLET_OUT_OF_SYNC: 5021,
  INCOMPATIBLE_WALLET_API: 5022,
  PLAYER_SELF_EXCLUDED: 5023,

  BET_ROLLED_BACK: 5030,
  BET_ROLLED_BACK_FATAL: 5031,

  PLAYTECH_ERROR: 5032,
  PLAYTECH_ERROR_CRITICAL: 5033,

  JB_TRANSLATION_ERROR: 8001,
};

export const ERROR_CATEGORIES = {
  DEFAULT: "DEFAULT",
  FATAL_STOP_LOGOUT: "FATAL_STOP_LOGOUT",
  ROLLBACK: "ROLLBACK",
  ROLLBACK_FATAL: "ROLLBACK_FATAL",
  COOLDOWN: "COOLDOWN",
  ROUND_ENDED: "ROUND_ENDED",
  REDIRECT: "REDIRECT",
};

export const ERROR_CATEGORIES_CODES: Record<string, Array<number | string>> = {
  [ERROR_CATEGORIES.FATAL_STOP_LOGOUT]: [
    ERROR_CODES.INCOMPATIBLE_WALLET_API,
    ERROR_CODES.WALLET_BLOCKS_PLAYER,
    ERROR_CODES.SESSION_CLOSED,
    ERROR_CODES.WALLET_CLOSED_GAME,
    ERROR_CODES.WALLET_SERVER_EXC,
    ERROR_CODES.WALLET_BLOCKS_BET,
    ERROR_CODES.WALLET_BLOCKS_WIN,
    ERROR_CODES.PLAYTECH_ERROR_CRITICAL,
    ERROR_CODES.PLAYER_SELF_EXCLUDED,
    ERROR_CODES.SERVICE_UNAVAILABLE,
    ERROR_CODES.ANOTHER_GAME_OPEN,
    ERROR_CODES.BAD_REQUEST,
    ERROR_CODES.ROUND_NOT_FOUND,
  ],
  [ERROR_CATEGORIES.ROLLBACK]: [
    ERROR_CODES.ERROR_BUTTONS,
    ERROR_CODES.CZECH_REGULATION,
    ERROR_CODES.HOUR_LOSS_LIMIT,
    ERROR_CODES.DAILY_LOSS_LIMIT,
    ERROR_CODES.WEEK_LOSS_LIMIT,
    ERROR_CODES.MONTH_LOSS_LIMIT,
    ERROR_CODES.DAILY_BET_LIMIT,
    ERROR_CODES.WEEKLY_BET_LIMIT,
    ERROR_CODES.MONTHLY_BET_LIMIT,
    ERROR_CODES.LIMIT_IS_MISSING,
    ERROR_CODES.WITHDRAW_LIMIT,
    ERROR_CODES.WALLET_OUT_OF_SYNC,
    ERROR_CODES.INSUFFICIENT_CREDIT,
    ERROR_CODES.PLAYER_LIMIT_EXCEEDED,
    ERROR_CODES.PLAYTECH_ERROR,
    ERROR_CODES.GAME_NOT_ENABLED,
    ERROR_CODES.BET_ROLLED_BACK,
    ERROR_CODES.WALLET_CANCEL_DUPLICATE,
    ERROR_CODES.FREESPINS_EXPIRED,
    ERROR_CODES.FREESPINS_ALREADY_REDEEMED,
  ],
  [ERROR_CATEGORIES.ROLLBACK_FATAL]: [ERROR_CODES.BET_ROLLED_BACK_FATAL],
  [ERROR_CATEGORIES.COOLDOWN]: [ERROR_CODES.COOLDOWN],
  [ERROR_CATEGORIES.ROUND_ENDED]: [ERROR_CODES.ROUND_ENDED],
  [ERROR_CATEGORIES.REDIRECT]: [ERROR_CODES.REDIRECT],
};

export function getErrorCategoryByCode(code: number | string): string {
  if (code == null) {
    return ERROR_CATEGORIES.DEFAULT;
  }

  for (let category in ERROR_CATEGORIES_CODES) {
    if (ERROR_CATEGORIES_CODES[category].indexOf(code) != -1) {
      return category;
    }
  }

  return ERROR_CATEGORIES.DEFAULT;
}
